<div class="text-center">
  <a class="btn btn-primary" (click)="navigateToAdd()">Add Statement</a>
</div>
<div>
  <app-base-report
    *ngIf="data"
    [hasDateRangeFilter]="false"
    [hasCheckboxes]="false"
    [reportName]="'Fraud Statement'"
    [rowActions]="actions"
    [defaultColumns]="properties"
    [columnsDisplayNames]="displayTableColumns"
    [data]="data"
    [rowsLength]="totalRecords"
    (filterTrigger)="getCurrentPage($event)"
    (paginationChange)="paginate($event)"
    (searchChange)="searchChange($event)"
    [tableLoading]="loading"
    [columnTypes]="columnTypes"
    [hasSort]="true"
    (sortTrigger)="sortChange($event)"
    (rowActionClicked)="actionEmiter($event)"
  >
  </app-base-report>
</div>
